export const CADASTRO = {
    SET_FIELD: 'CADASTRO/SET_FIELD',
    LOAD_PROCESS: 'CADASTRO/LOAD_PROCESS',
    CREATE_PROCESS: 'CADASTRO/CREATE_PROCESS',
    SALVA_PLANO: 'CADASTRO/SALVA_PLANO',
    CRIA_STRIPE_LINK: 'CADASTRO/STRIPE_LINK',
}